<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-5">Data Sesi WhatsApp</span>
		</div>
		<div class="card-body">
			<el-table :data="sessions" table-layout="auto" border stripe v-loading="loading" :header-cell-style="{ background: 'var(--el-fill-color-light)' }" class="shadow-sm">
				<template #empty>
					<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
				</template>
				<el-table-column type="index" label="No." align="center" />
				<el-table-column prop="id" label="ID Sesi" align="center" />
				<el-table-column prop="nomor" label="Nomor" align="center" />
				<el-table-column label="Status" align="center">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<span :key="row.status">
								{{ statuses[row.status] || row.status }}
							</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Tindakan" align="center">
					<template #default="{ row }">
						<el-tooltip :content="actionStatus[row.id]?.action ? actionStatus[row.id].process : 'Tautkan sesi WhatsApp'" v-if="row.status === 'inactive'">
							<el-button
								type="info"
								size="small"
								plain
								round
								@click="initSession(row)"
								icon="Connection"
								:loading="actionStatus[row.id]?.loading && actionStatus[row.id]?.action === 'init'"
								:disabled="actionStatus[row.id]?.loading && actionStatus[row.id]?.action !== 'init'" />
						</el-tooltip>
						<el-space v-else>
							<el-tooltip :content="actionStatus[row.id]?.action ? actionStatus[row.id].process : 'Tampilkan kode QR'" v-if="row.status === 'qr'">
								<el-button type="info" size="small" plain round @click="selectedData = row" :disabled="actionStatus[row.id]?.loading">
									<el-icon><i class="bi bi-qr-code-scan"></i></el-icon>
								</el-button>
							</el-tooltip>
							<el-tooltip :content="actionStatus[row.id]?.action ? actionStatus[row.id].process : 'Ganti sesi'" v-else>
								<span>
									<el-popconfirm
										:title="`Ganti sesi [${row.id}]?`"
										confirm-button-type="primary"
										confirm-button-text="Ya, Ganti"
										cancel-button-text="Batal"
										hide-icon
										width="200"
										@confirm="reinitSession(row)">
										<template #reference>
											<el-button
												type="primary"
												size="small"
												plain
												round
												icon="Refresh"
												:loading="actionStatus[row.id]?.loading && actionStatus[row.id]?.action === 'reinit'"
												:disabled="actionStatus[row.id]?.loading && actionStatus[row.id]?.action !== 'reinit'" />
										</template>
									</el-popconfirm>
								</span>
							</el-tooltip>
							<el-tooltip :content="actionStatus[row.id]?.loading ? actionStatus[row.id].process : 'Hapus sesi'">
								<span>
									<el-popconfirm
										:title="`Anda yakin ingin menghapus sesi [${row.id}]?`"
										confirm-button-type="danger"
										confirm-button-text="Ya, Hapus"
										cancel-button-text="Batal"
										hide-icon
										width="200"
										@confirm="deleteSession(row)">
										<template #reference>
											<el-button
												type="danger"
												size="small"
												plain
												round
												icon="Delete"
												:loading="actionStatus[row.id]?.loading && actionStatus[row.id]?.action === 'delete'"
												:disabled="actionStatus[row.id]?.loading && actionStatus[row.id]?.action !== 'delete'" />
										</template>
									</el-popconfirm>
								</span>
							</el-tooltip>
						</el-space>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog v-model="qrDialogVisible" align-center @closed="selectedData = null" width="auto">
			<template #header>
				Pindai Kode QR [
				<code class="fw-bold">{{ selectedData?.id }}</code>
				]
			</template>
			<div class="text-center">
				<img :src="selectedData.qr" alt="" v-if="selectedData?.qr" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "WaSessionsView",
	data() {
		return {
			sessions: [],
			statuses: {
				initializing: "Menginisalisasi",
				authenticated: "Terautentikasi",
				ready: "Siap",
				qr: "Pinda kode QR!",
				inactive: "Belum ditautkan",
			},
			loading: true,
			actionStatus: {},
			qrDialogVisible: false,
			selectedData: null,
		};
	},
	computed: {},
	watch: {
		selectedData(val) {
			if (val) {
				this.qrDialogVisible = true;
			}
		},
	},
	mounted() {
		this.$ws.main.on("wa:status", this.updatedSession);
		this.getSessions();
	},
	beforeUnmount() {
		this.$ws.main.off("wa:status");
	},
	methods: {
		updatedSession(data) {
			const d = JSON.parse(data);

			let isExist = false;
			for (const s of this.sessions) {
				if (s.id === d.id) {
					isExist = true;
					if (d.status === "deleted") {
						s.status = "inactive";
						break;
					}
					s.status = d.status;
					s.qr = d.qr;
					if (d.status === "qr") {
						this.actionStatus[d.id] = {
							loading: false,
							action: null,
							process: null,
						};
					} else {
						if (d.id === this.selectedData?.id && this.qrDialogVisible) {
							this.$notify.success({
								title: "Berhasil",
								message: `Kode QR sesi [${d.id}] berhasil dipindai`,
							});
							this.qrDialogVisible = false;
						}
						s.qr = null;
					}
					break;
				}
			}
			if (!isExist) {
				this.loading = true;
				this.sessions.push(d);
				this.actionStatus[d.id] = {
					loading: true,
					action: "initializing",
					process: "Sedang menginisialisasi sesi",
				};
				setTimeout(() => {
					this.loading = false;
				}, 500);
			}
		},
		async getSessions() {
			try {
				const { data } = await this.$defaultApi.post("/wa/sessions");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.sessions = data.sessions;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async initSession(sesi) {
			this.actionStatus[sesi.id] = { loading: true, action: "init", process: "Sedang menautkan sesi" };
			try {
				const { data } = await this.$defaultApi.post("/wa/session/create", {
					session_id: sesi.id,
				});
				setTimeout(() => {
					this.$notify.success({
						title: "Berhasil",
						message: data.message,
					});

					this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
			}
		},
		async reinitSession(sesi) {
			this.actionStatus[sesi.id] = { loading: true, action: "reinit", process: "Sedang memperbarui sesi" };
			try {
				const { data } = await this.$defaultApi.post("/wa/session/reinit", {
					session_id: sesi.id,
				});
				setTimeout(() => {
					this.$notify.success({
						title: "Berhasil",
						message: data.message,
					});

					this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
			}
		},
		async deleteSession(sesi) {
			this.actionStatus[sesi.id] = { loading: true, action: "delete", process: "Sedang menghapus sesi" };
			try {
				const { data } = await this.$defaultApi.post("/wa/session/delete", {
					session_id: sesi.id,
				});
				setTimeout(() => {
					this.$notify.success({
						title: "Berhasil",
						message: data.message,
					});

					this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.actionStatus[sesi.id] = { loading: false, action: null, process: null };
			}
		},
	},
};
</script>

<style scoped></style>
